import type { ExtractPropTypes, PropType } from 'vue'
import type Button from './Button.vue'

const validColors = ['primary', 'error', 'warning', 'success', ''] as const

type ButtonColorType = (typeof validColors)[number]

export const buttonProps = {
  color: {
    type: String as PropType<ButtonColorType>,
    validator: (v: ButtonColorType) => validColors.includes(v),
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  preIcon: { type: String },
  postIcon: { type: String },
  iconSize: { type: Number, default: 14 },
  onClick: {
    type: [Function, Array] as PropType<(() => any) | (() => any)[]>,
    default: null,
  },
} as const

export const buttonEmits = {
  onClick: (event: MouseEvent) => event instanceof MouseEvent,
}

export type ButtonInstance = InstanceType<typeof Button>
export type ButtonProps = ExtractPropTypes<typeof buttonProps>
export type ButtonEmits = typeof buttonEmits
